// extracted by mini-css-extract-plugin
export var actionButton = "_jj-t";
export var buttonContainer = "_jj-0";
export var buttonContainer2 = "_jj-1";
export var buttonSection = "_jj-2";
export var details = "_jj-3";
export var dropdownItem = "_jj-5";
export var dropdownItemsContainer = "_jj-4";
export var fileInput = "_jj-r";
export var headerButton = "_jj-6";
export var icon = "_jj-7";
export var input = "_jj-8";
export var macroListItem = "_jj-9";
export var mainContent = "_jj-a";
export var microText = "_jj-b";
export var modal = "_jj-w";
export var optionsButton = "_jj-c";
export var paperclip = "_jj-s";
export var pillContent = "_jj-d";
export var preview = "_jj-e";
export var preview2 = "_jj-f";
export var quillEditor = "_jj-q";
export var selectedMacro = "_jj-g";
export var sidebar = "_jj-h";
export var sidebarHeader = "_jj-j";
export var sidebarList = "_jj-i";
export var sidebarListItem = "_jj-k";
export var sidebarSearch = "_jj-l";
export var snoozeDurationWrapper = "_jj-v";
export var statusPillContainer = "_jj-m";
export var tagsContainer = "_jj-n";
export var unselectedMacro = "_jj-o";
export var variable = "_jj-u";
export var wrapper = "_jj-p";